import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  sortBy,
} from 'lodash/fp';
import styles from './tableHeader.scss';

const sort = sortBy(({ idx }) => idx);
const sortArrow = {
  ASC: '▲',
  DESC: '▼',
};

const TableHeader = ({
  columns,
  activeSort,
  changeSort,
  isTwoCol,
}) => (
  <thead className={styles.tableHeader}>
    <tr className={styles.row}>
      {sort(columns)
        .map(({
          idx,
          colId,
          fixed,
          label,
        }) => (
          <th
            key={colId}
            className={classNames({
              [styles.cell]: true,
              [styles.fixed]: fixed && !isTwoCol,
              [styles.alignLeft]: isTwoCol && 0 === idx,
            })}
            onClick={() => changeSort({ column: idx })}
          >
            <span className={activeSort.column === idx ?
              styles.activeSort : styles.inactiveSort
            }
            >
              <span
                className={styles.arrow}
                aria-hidden={activeSort.column !== idx}
              >
                {sortArrow[activeSort.dir]}
              </span>
              <span
                className={classNames({
                  [styles.yearDisplay]: 0 !== idx,
                })}
              >
                {label}
              </span>
            </span>
          </th>
        ))}
    </tr>
  </thead>
);

TableHeader.defaultProps = {
  isTwoCol: false,
};

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      idx: PropTypes.number.isRequired,
      colId: PropTypes.string.isRequired,
      label: PropTypes.string,
      fixed: PropTypes.oneOf(['left', 'right']),
    })
  ).isRequired,
  activeSort: PropTypes.shape({
    column: PropTypes.number.isRequired,
    dir: PropTypes.oneOf(['ASC', 'DESC']),
  }).isRequired,
  changeSort: PropTypes.func.isRequired,
  isTwoCol: PropTypes.bool,
};

export default TableHeader;



// WEBPACK FOOTER //
// ./app/components/tableHeader/index.js